/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import * as Yup from 'yup';

import { JiraCustomerSupportTicket } from '../../../types/support/JiraSupport';
import { IUser } from '../../../types/user/IUser';

export type JiraSupportPageProps = {
  user?: IUser;
};

export enum ModalTypes {
  CREATE = 'CREATE',
  VIEW = 'VIEW',
}

type CommonModalProps = {
  onClose: () => void;
};

export type ModalProps = {
  type: ModalTypes;
  ticketId?: string;
};

export type ViewTicketModalProps = CommonModalProps & {
  ticketId?: string;
};

export type CreateTicketControlProps = CommonModalProps & {
  user?: IUser;
  onSuccess: () => void;
};

export type TicketCommentsProps = {
  id: string;
};

export type FetchParams = {
  requestStatus: 'open' | 'closed' | 'all';
  take: number;
  skip: number;
};

export const emptyTicket: JiraCustomerSupportTicket = {
  issueId: '',
  issueKey: '',
  summary: '',
  description: '',
  clusterSupportLevelId: '',
  clusterId: '',
  organizationId: '',
  createdAt: '',
  status: {
    name: '',
    category: '',
  },
  metaData: {
    'User ID': '',
  },
  requestTypeId: '',
  serviceDeskId: '',
  userId: '',
  companyName: '',
  projectId: '',
  supportPlanName: '',
  clusterName: '',
  organizationName: '',
  userName: '',
  projectName: '',
} as const;

export const validationSchema = Yup.object({
  summary: Yup.string().required('empty'),
  description: Yup.string().required('empty'),
  clusterSupportLevelId: Yup.string().required('empty'),
  clusterId: Yup.string().required('empty'),
  organizationId: Yup.string(),
  projectId: Yup.string(),
  clusterName: Yup.string(),
  organizationName: Yup.string(),
  userName: Yup.string(),
  supportPlanName: Yup.string(),
  projectName: Yup.string(),
});

export const initialValues = {
  summary: '',
  description: '',
  clusterSupportLevelId: '',
  clusterId: '',
  projectId: '',
} as const;

export const commentValidationSchema = Yup.object({
  body: Yup.string().required('empty'),
});

export const commentInitialValues = {
  body: '',
} as const;
